import { render, staticRenderFns } from "./indexv3.vue?vue&type=template&id=40e50cc4&"
import script from "./indexv3.vue?vue&type=script&lang=js&"
export * from "./indexv3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports